import React, {useEffect, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import { FaHome } from "react-icons/fa";
import { MdOutlineSlowMotionVideo } from "react-icons/md";
import { FaRegUser } from "react-icons/fa";
 import { useAppDispatch } from '../store/hooks';
 import { activetabslice, activeCategorySlice, setFooNavHeightSlice } from '../store/navigationSlice'; 
interface TabsProps {
  activeTab: string;
  darkMode: boolean;
}

const Footer:React.FC<TabsProps> = ({darkMode, activeTab}) => {  
  const fooNavRef = useRef<HTMLElement>(null);
  const dispatch = useAppDispatch();
const navigate = useNavigate();

    const setActiveTab = (val:string) => {
      if(val ==='home'){
         dispatch(activeCategorySlice('homepage'));
         navigate('/');        
      }
      if(val =='shorts'){
         dispatch(activeCategorySlice('shorts'));
      }
      dispatch(activetabslice(val))
    }
    
useEffect(() => {
  if (!fooNavRef.current) return;

  const observer = new ResizeObserver((entries) => {
    for (let entry of entries) {
      const height = entry.contentRect.height;
      dispatch(setFooNavHeightSlice(height));
    }
  });

  observer.observe(fooNavRef.current);

  return () => {
    observer.disconnect();
  };
}, [dispatch]);

    return (
        <nav ref={fooNavRef} className={`fixed bottom-tab bottom-0 w-full ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border-t z-10`}>
      <div className="grid grid-cols-3 h-15">
        <button 
          onClick={() => setActiveTab('home')}
          className={`flex flex-col items-center justify-center py-2 cursor-pointer rounded-button ${activeTab === 'home' ? (darkMode ? 'text-orange-400' : 'text-orange-500') : (darkMode ? 'text-gray-400' : 'text-gray-500')}`}
        >
         <FaHome size={20} />
          <span className="text-xs mt-1">Home</span>
        </button>
        
        <button 
 onClick={() => {
  setActiveTab('shorts');
  navigate('/shorts');
}}
       
          className={`flex flex-col items-center justify-center py-2 cursor-pointer rounded-button ${activeTab === 'shorts' ? (darkMode ? 'text-orange-400' : 'text-orange-500') : (darkMode ? 'text-gray-400' : 'text-gray-500')}`}
        >
          <MdOutlineSlowMotionVideo />
          <span className="text-xs mt-1">Shorts</span>
        </button>
 {/* <Link to="/videos" className={`flex flex-col items-center justify-center py-2 cursor-pointer rounded-button ${activeTab === 'videos' ? (darkMode ? 'text-orange-400' : 'text-orange-500') : (darkMode ? 'text-gray-400' : 'text-gray-500')}`}>  <MdOutlineSlowMotionVideo /> <span className="text-xs mt-1">Videos</span></Link> */}
 
      
        
        <button 
          onClick={() => setActiveTab('profile')}
          className={`flex flex-col items-center justify-center py-2 cursor-pointer rounded-button ${activeTab === 'profile' ? (darkMode ? 'text-orange-400' : 'text-orange-500') : (darkMode ? 'text-gray-400' : 'text-gray-500')}`}
        >
          {/* <CiUser /> */}
          <FaRegUser />
          
          <span className="text-xs mt-1">Profile</span>
        </button>
      </div>
    </nav>
    )
}

export default Footer;